import { useTranslations } from "next-intl";

const CartSummaryDetails = ({
  totalPrice,
  adjustedTotalPrice,
}: {
  totalPrice: number;
  adjustedTotalPrice: number;
}) => {
  const t = useTranslations('ui');
  const discount = totalPrice - adjustedTotalPrice;
  const discountPercent = Math.round((discount / totalPrice) * 100);

  return (
    <div className="flex flex-col space-y-5">
      <div className="flex items-center justify-between">
        <span className="md:text-xl text-black/60">Subtotal</span>
        <span className="md:text-xl font-bold">${totalPrice}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="md:text-xl text-black/60">Discount (-{discountPercent}%)</span>
        <span className="md:text-xl font-bold text-red-600">-${discount}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="md:text-xl text-black/60">Delivery Fee</span>
        <span className="md:text-xl font-bold">Free</span>
      </div>
      <hr className="border-t-black/10" />
      <div className="flex items-center justify-between">
        <span className="md:text-xl text-black">Total</span>
        <span className="text-xl md:text-2xl font-bold">${adjustedTotalPrice}</span>
      </div>
    </div>
  );
};

export default CartSummaryDetails;